import en from './en.js'
import zhTW from './zhTw.js'
import zhCN from './zhCN.js'
export default {
    en: en.en,
    'zh-TW': zhTW['zh-TW'],
    'zh-CN': zhCN['zh-CN']
}



// WEBPACK FOOTER //
// ./src/i18n/index.js